module.exports = __webpack_public_path__ + "img/image8.4e0dafdf.jpg";